<template>
  <div class="lingqujilu-page common-bg">
    <div class="filter-bar">
      <div class="filter-item" @click="showTime = !showTime">
        <span>{{ timeOptions[timeIndex].text }}</span>
        <van-icon name="arrow-down" size="10" />
        <div class="filter-dropdown" v-show="showTime">
          <div v-for="(opt, idx) in timeOptions" :key="idx" 
               class="filter-option" :class="{ active: timeIndex === idx }"
               @click="timeIndex = idx; showTime = false;">{{ opt.text }}</div>
        </div>
      </div>
      <div class="filter-item" @click="showStatus = !showStatus">
        <span>{{ statusOptions[statusIndex].text }}</span>
        <van-icon name="arrow-down" size="10" />
        <div class="filter-dropdown" v-show="showStatus">
          <div v-for="(opt, idx) in statusOptions" :key="idx" 
               class="filter-option" :class="{ active: statusIndex === idx }"
               @click="statusIndex = idx; showStatus = false;">{{ opt.text }}</div>
        </div>
      </div>
      <div class="filter-item" @click="showType = !showType">
        <span>{{ typeOptions[typeIndex].text }}</span>
        <van-icon name="arrow-down" size="10" />
        <div class="filter-dropdown" v-show="showType">
          <div v-for="(opt, idx) in typeOptions" :key="idx" 
               class="filter-option" :class="{ active: typeIndex === idx }"
               @click="typeIndex = idx; showType = false;">{{ opt.text }}</div>
        </div>
      </div>
      <div class="bonus-amount">奖金 {{ bonusAmount }}</div>
    </div>

    <div class="record-list" v-if="recordList.length > 0">
      <div class="record-item" v-for="(item, index) in recordList" :key="index">
        <div class="record-icon"><van-icon name="gold-coin" size="32" color="#DFB372" /></div>
        <div class="record-info">
          <div class="record-title">{{ item.title }}</div>
          <div class="record-time">{{ item.time }}</div>
        </div>
        <div class="record-amount">{{ item.amount }}</div>
      </div>
    </div>
    <div class="record-empty" v-else>
      <div class="empty-icon-wrap">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
      </div>
      <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'lingqujiluComponents',
  data() {
    return {
      timeIndex: 0,
      statusIndex: 0,
      typeIndex: 0,
      showTime: false,
      showStatus: false,
      showType: false,
      bonusAmount: '0.00',
      timeOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '本月', value: 3 },
        { text: '全部', value: 4 },
      ],
      statusOptions: [
        { text: '全部状态', value: 0 },
        { text: '已完成', value: 1 },
        { text: '进行中', value: 2 },
        { text: '未开始', value: 3 },
      ],
      typeOptions: [
        { text: '全部类型', value: 0 },
        { text: '签到奖金', value: 1 },
        { text: '额外奖金', value: 2 },
        { text: '活跃度', value: 3 },
        { text: '积分', value: 4 },
        { text: '幸运值', value: 5 },
      ],
      recordList: [],
      allList: [],
      page: 1,
      lastPage: 1,
    };
  },
  mounted() {
    this.getRecords();
  },
  watch: {
    timeIndex() {
      this.page = 1;
      this.getRecords();
    },
    typeIndex() {
      this.applyTypeFilter();
    },
  },
  methods: {
    getRecords() {
      let that = this;
      if (!that.$store.state.token) {
        return;
      }
      that.$apiFun.checkinRecords({
        time_type: that.timeOptions[that.timeIndex].value,
        page: that.page,
      }).then(res => {
        if (res.code === 200 && res.data) {
          that.allList = res.data.list || [];
          that.bonusAmount = res.data.bonus_amount || '0.00';
          that.lastPage = res.data.last_page || 1;
          that.applyTypeFilter();
        }
      }).catch(() => {});
    },
    applyTypeFilter() {
      let type = this.typeOptions[this.typeIndex].value;
      if (type === 1 || type === 2) {
        this.recordList = this.allList.filter(item => item.kind === type);
      } else if (type === 0) {
        this.recordList = this.allList;
      } else {
        this.recordList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lingqujilu-page {
  min-height: 80vh;
  margin-top: 44px;
  padding-bottom: 100px;

  .filter-bar {
    background: #292A2C;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 6px 10px;
      background: #1E1F24;
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      position: relative;

      .filter-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: #292A2C;
        border-radius: 4px;
        overflow: hidden;
        z-index: 100;
        max-height: 200px;
        overflow-y: auto;

        .filter-option {
          padding: 10px;
          text-align: center;
          font-size: 12px;
          color: #888;

          &.active {
            color: #DFB372;
            background: rgba(223, 179, 114, 0.1);
          }
        }
      }
    }

    .bonus-amount {
      font-size: 12px;
      color: #DFB372;
    }
  }

  .record-list {
    padding: 15px;

    .record-item {
      display: flex;
      align-items: center;
      padding: 15px;
      background: #292A2C;
      border-radius: 8px;
      margin-bottom: 10px;

      .record-icon {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #1E1F24;
        border-radius: 50%;
        margin-right: 15px;
      }

      .record-info {
        flex: 1;

        .record-title {
          font-size: 14px;
          color: #fff;
          margin-bottom: 5px;
        }

        .record-time {
          font-size: 12px;
          color: #888;
        }
      }

      .record-amount {
        font-size: 14px;
        color: #DFB372;
        font-weight: bold;

        &.minus {
          color: #ff4d4f;
        }
      }
    }
  }

  .record-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 0;

    .empty-icon-wrap {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.4rem;

      .empty-icon {
        width: 2.5rem;
        height: 2.5rem;
        opacity: 0.5;
      }
    }

    .empty-text {
      font-size: 0.28rem;
      color: #666;

      .empty-link {
        color: #DFB372;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/component/lingqujilu.vue